import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import {
  AerosolArea,
  AerosolShutdownDesign
} from '@authority-labs/api-interfaces';
import { cloneDeep } from 'lodash';

@Component({
  selector: 'authority-labs-aerosol-shutdown',
  templateUrl: './aerosol-shutdown.component.html',
  styleUrls: ['./aerosol-shutdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AerosolShutdownComponent {
  @Input() data: AerosolShutdownDesign;
  @Input() readonly: boolean;
  @Input() printPreview: boolean;
  @Output() dataChange: EventEmitter<void> = new EventEmitter();

  selectedTab = 0;

  onDataChange(): void {
    this.dataChange.emit();
  }

  tabName(index: number) {
    return `מערכת ${index + 1}`;
  }

  addTest(): void {
    this.data.areas.push(new AerosolArea());
    this.selectedTab = this.data.areas.length - 1;
    this.onDataChange();
  }

  duplicateTest(): void {
    const data = cloneDeep(this.data.areas[this.selectedTab]);
    this.data.areas.push(new AerosolArea(data));
    this.selectedTab = this.data.areas.length - 1;
    this.onDataChange();
  }

  removeTest(): void {
    this.data.areas.splice(this.selectedTab, 1);
    this.onDataChange();
  }
}
